/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customFontIndex } from '../../axios/customFontIndex'
import type {
	CustomFontIndexError,
	CustomFontIndexPathParams,
	CustomFontIndexResponse,
} from '../../types/CustomFontIndex'

export const customFontIndexQueryKey = (organisation: CustomFontIndexPathParams['organisation']) =>
	[{ url: '/organisations/:organisation/fonts', params: { organisation } }] as const

export type CustomFontIndexQueryKey = ReturnType<typeof customFontIndexQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/CustomFontController.php CustomFontController::index */
export function customFontIndexQueryOptions(
	organisation: CustomFontIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CustomFontIndexResponse,
		AxiosError<CustomFontIndexError>,
		CustomFontIndexResponse,
		CustomFontIndexQueryKey
	>({
		queryKey: customFontIndexQueryKey(organisation),
		queryFn: ({ signal }) => customFontIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/CustomFontController.php CustomFontController::index */
export function useCustomFontIndex<TSelectData = CustomFontIndexResponse>(
	organisation: CustomFontIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CustomFontIndexResponse,
					AxiosError<CustomFontIndexError>,
					TSelectData,
					CustomFontIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CustomFontIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...customFontIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/CustomFontController.php CustomFontController::index */
export function useCustomFontIndexSuspense<TSelectData = CustomFontIndexResponse>(
	organisation: CustomFontIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CustomFontIndexResponse,
					AxiosError<CustomFontIndexError>,
					TSelectData,
					CustomFontIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CustomFontIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...customFontIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
